import { useApi, SKY_API_ENDPOINT } from '@/api';
import { KpiCard, LinkBanner, Page } from '@/components';
import { useSearchParams } from '@/hooks';
import { Box, Flex, Heading } from '@blockanalitica/ui';
import BackstopAssetDistribution from './BackstopAssetDistribution';
import HistoricTabs from './HistoricTabs';

export default function AggregateBackstopPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [response, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: '/backstop/',
    queryParams: {
      days_ago: daysAgo
    }
  });
  const data = response?.data;

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page title="Aggregate Backstop Capital">
        <Flex gap={['m', 's']} flexDirection={'column'}>
          <LinkBanner
            text={"More About the Sky Protocol's Backstop Capital"}
            linkTo="https://sky-atlas.io/#A.3.6">
            <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
              <Heading size="2">
                About the Sky Protocol Backstop Capital
              </Heading>
              <br />
              This page provides a breakdown of Aggregate Backstop Capital in
              the Sky Ecosystem. The Aggregate Capital Buffer combines backstop
              capital from the Sky Surplus Buffer and Genesis Capital, held
              within the Subproxies of Genesis Agents. These Subproxies are
              technically controlled by Sky Governance and are mandated to
              transfer eligible assets to the Sky Surplus Buffer when required
              for Genesis Capital Backstops.
            </Box>
          </LinkBanner>
          <KpiCard
            title="Aggregate Backstop Capital"
            data={data}
            field="aggregate_backstop_capital"
            options={{
              currency: 'USD',
              notation: 'standard'
            }}
          />
        </Flex>

        <HistoricTabs />
        <BackstopAssetDistribution />
      </Page>
    );
  }
  return null;
}
